export default __webpack_public_path__ + "static/media/unilever.2ebc05d6.png";